import * as TYPES from './type';
export default {
  //课中活动讨论
  [TYPES.SIGN_LIST](state, { result }) {
    state.signList = result.result
  },
  [TYPES.SIGN_INFO](state, { result, type }) {
    state.signInfo[type] = result.result
  },
}